// assets/collection-instock-default.js
// Force "in stock" filter on collection pages and keep it through pagination.
// Works even if body classes differ or sections re-render.

(function () {
  // Heuristics to detect a collection page:
  const isCollectionPage =
    location.pathname.startsWith('/collections/') ||
    document.getElementById('product-grid') ||
    document.body.className.includes('template-collection');

  if (!isCollectionPage) return;

  const currentUrl = new URL(window.location.href);

  // Allow bypass if you append ?show_sold_out=1
  if (currentUrl.searchParams.get('show_sold_out') === '1') return;

  // If the in-stock filter is missing, add it and reload ONCE
  if (!currentUrl.searchParams.has('filter.v.availability')) {
    currentUrl.searchParams.set('filter.v.availability', '1');
    window.location.replace(currentUrl.toString());
    return;
  }

  // Ensure pagination links keep the filter
  function patchPaginationLinks(root) {
    const linkSelectors = [
      'a[href*="page="]',
      '.pagination a',
      'a.pagination__item',
      'a[href*="cursor="]' // some themes use cursor/next links
    ];
    const links = root.querySelectorAll(linkSelectors.join(','));
    links.forEach(a => {
      if (!a || !a.href) return;
      try {
        const u = new URL(a.href, window.location.origin);
        if (!u.searchParams.has('filter.v.availability')) {
          u.searchParams.set('filter.v.availability', '1');
        }
        // preserve opt-out flag if present
        if (currentUrl.searchParams.get('show_sold_out') === '1') {
          u.searchParams.set('show_sold_out', '1');
        }
        a.href = u.toString();
      } catch (e) {}
    });
  }

  // Initial pass
  patchPaginationLinks(document);

  // Observe for section re-renders (filters/sort)
  const obs = new MutationObserver(() => patchPaginationLinks(document));
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();